<template>
  <section
    class="media-buying media-buying-ad"
    :class="{ wavebg: loading }"
  >
    <TableCard
      ref="datatable"
      v-model:sort="sorting"
      v-model:page="page"
      v-model:page-size="pageSize"
      class="media-buying-ad__table campaign-table"
      :loading="loading"
      :columns="columns"
      :sort-by-name="sortByName"
      :sort-dir-name="sortDirName"
      :rows="rows"
      :currency="currencyLabel"
      :count="$store.state.mediaBuying.campaignsCount"
      :formaters="formaters"
      :actions="actions"
      is-static
      extend-height
      dont-fill-empty
      custom-context
      placement-tooltip="bottom"
      i18n-path="mediaBuying.channels"
      is-row-clickable
      @fetch-data="fetchDataTable"
      @checked-rows="handleCheckedRows"
    >
      <template v-slot:header>
        <div class="table-card__header-title ui-g-md">
          <span>{{ $t('mediaBuying.campaigns.adCampaigns') }}</span>
          <button
            :class="[
              'btn',
              'btn-primary',
              'btn-sm',
              '!tw-whitespace-nowrap',
              'campaign-add-btn',
              'campaign-add-btn--header',
            ]"
            @click="addCampaign"
          >
            +&nbsp;{{ $t('mediaBuying.campaigns.add_campaign') }}
          </button>
        </div>
        <div
          :class="[
            'ui-d-flex',
            'ui-align-center',
            'ui-desktop-no-wrap',
            'ui-mobile-wrap',
            'ui-mobile-12',
          ]"
        >
          <TableCardSearchHeader
            v-model="search"
            class="ui-g-md"
            @search="handleSearch"
          />
          <PeriodWrapper
            class="ui-g-md ui-mobile-12"
            default-all-time
            :settings="period"
            @update="onPeriodUpdate"
            @change="fetchDataTable"
          />
          <UiSelect
            v-model="status"
            class="mobile:!tw-w-full ui-g-md"
            :list="statusFilters"
            :empty-values="[null]"
            :value-on-clear="null"
            width="200"
            @change="selectStatusCampaign"
          />
          <div
            class="checkbox payment-history__checkbox ui-mobile-12 ui-g-md"
          >
            <input
              id="checkbox1"
              v-model="needs_attention_first"
              type="checkbox"
              @change="fetchDataAction"
            >
            <label
              class="checkbox-label checkbox-label__action-required"
              for="checkbox1"
            >
              {{ $t('mediaBuying.campaign.action_required') }}
            </label>
          </div>
        </div>
      </template>
      <template v-slot:actionsPrepend>
        <div class="ui-g-md ui-mobile-12 campaign-add-btn campaign-add-btn--inline">
          <button
            :class="[
              'btn',
              'btn-primary',
              'btn-sm',
              '!tw-whitespace-nowrap',
              'ui-mobile-12',
            ]"
            @click="addCampaign"
          >
            +&nbsp;{{ $t('mediaBuying.campaigns.add_campaign') }}
          </button>
        </div>
      </template>
    </TableCard>

    <EditCampaign
      id="adversitingCampaign"
      ref="editCampaign"
      @add-campaign="refresh"
    />
  </section>
</template>

<script>
import UrlMixin from '@/components/Query/url-mixin';
import UrlMixinHooks from '@/components/Query/url-mixin-hooks';
import InjectPlugins from '@/components/Report/Components/inject-plugins';
import { pageSizeMixin } from '@/views/Dashboard/Reports/page_size';
import Formatters from '@/views/Dashboard/CustomReports/formaters';
import EditCampaign from '@/views/Dashboard/MediaBuying/Modal/EditCampaign.vue';
import TableCard from '@/components/Cards/TableCard.vue';
import TableCardSearchHeader from '@/components/Cards/TableCardSearchHeader.vue';
import PeriodWrapper from '@/views/Dashboard/Reports/Filters/PeriodWrapper.vue';
import HelpersMixin from '@/components/Helpers/helpers-mixin';
import tableFlowMixinGenerator from '@/views/Dashboard/Reports/tableFlowMixin';
import formatCurrency from '@/mixins/format-currency';
import UiTableAction from '@/components/ui/UiTableAction.vue';
import UiTablePopoverAction from '@/components/ui/UiTablePopoverAction.vue';

const allTimePeriod = { from: '', to: '', period: 2 };

const defaultParams = {
  page: 1,
  pageSize: 20,
  search: '',
  sort_column: 'created_at',
  sort_dir: 'desc',
  status: 'active',
  root_campaign_id: 'null',
  needs_attention_first: true,
};

const fetch = async (ctx, params) => {
  if (!params || ctx.$_.isEmpty(params)) {
    params = {
      ...defaultParams,
    };
  }

  const campaignsParams = {
    limit: params.limit || ctx.pageSize || defaultParams.pageSize,
    offset: 0,
    ...params,
    root_campaign_id: params.root_campaign_id || defaultParams.root_campaign_id,
    sort_column: params.sort_column || defaultParams.sort_column,
    sort_dir: params.sort_dir || defaultParams.sort_dir,
    status: params.status,
    needs_attention_first: params.needs_attention_first !== undefined
      ? params.needs_attention_first
      : defaultParams.needs_attention_first,
    stats_period_start: params.stats_period_start || params.period?.from || ctx.period?.from || undefined,
    stats_period_end: params.stats_period_end || params.period?.to || ctx.period?.to || undefined,
  };
  campaignsParams.sort_column = campaignsParams.sort_column !== 'channel_status'
    ? campaignsParams.sort_column
    : 'status';

  const campaigns = await ctx.$store.dispatch('getCampaigns', campaignsParams);
  return [campaigns];
};

const tableFlowMixin = tableFlowMixinGenerator({
  defaultParams: {
    ...defaultParams,
  },
  params: Object.keys(defaultParams),
  fetch,
  period: 'param',
  fromName: 'stats_period_start',
  toName: 'stats_period_end',
  windowRefreshHook: true,
  sortByName: 'sort_column',
  sortDirName: 'sort_dir',
});

export default {
  // name: 'Campaigns',
  name: 'AdvertisingCampaign',
  fetch,
  components: {
    EditCampaign,
    TableCard,
    TableCardSearchHeader,
    PeriodWrapper,
  },
  mixins: [
    UrlMixin,
    UrlMixinHooks,
    InjectPlugins,
    HelpersMixin,
    pageSizeMixin,
    tableFlowMixin,
    formatCurrency,
  ],
  props: ['fetchedData', 'passedParams'],
  data() {
    return {
      status: 'active',
      statusFiltersSettings: {
        minimumResultsForSearch: Infinity,
      },
      columns: [
        {
          name: 'incrementing_id',
          align: 'left',
          filterable: false,
          sortable: 'custom',
          width: 60,
        },
        {
          name: 'channel_status',
          align: 'center',
          filterable: true,
          width: 90,
          renderValue: (v) => `<span class="${v === 'active' ? 'green' : 'red'}">
              ${this.$t(`mediaBuying.channels.camp_status.${v}`)}
            </span>`,
        },
        {
          name: 'campaign_name',
          align: 'left',
          filterable: true,
          minWidth: 200,
          customTooltip: true,
          renderValue: (v) => `<span class="name-bubble !tw-flex !tw-justify-between">
                              <span class="link">${v.text}</span>
                            </span>`,
        },
        {
          name: 'balance_sum_approved',
          align: 'right',
          filterable: true,
          width: 130,
          format: 'currency',
        },
        {
          name: 'balance_sum_total',
          align: 'right',
          filterable: true,
          width: 130,
          format: 'currency',
        },
        {
          name: 'paid_sum_approved',
          align: 'right',
          filterable: true,
          width: 130,
          format: 'currency',
        },
        {
          name: 'paid_sum_pending',
          align: 'right',
          filterable: true,
          width: 130,
          format: 'currency',
        },
        {
          name: 'spent_sum_approved',
          align: 'right',
          filterable: true,
          width: 130,
          format: 'currency',
        },
        {
          name: 'spent_sum_pending',
          align: 'right',
          filterable: true,
          width: 130,
          format: 'currency',
        },
        {
          name: 'registrations_count',
          align: 'right',
          format: 'number',
          filterable: true,
          width: 110,
        },
        {
          name: 'first_deposits_count',
          align: 'right',
          filterable: true,
          format: 'number',
          width: 110,
        },
        {
          name: 'deposits_sum',
          align: 'right',
          filterable: true,
          // format: 'ncurrency',
          width: 110,
          format: 'currency',
        },
        {
          name: 'ggr_sum',
          align: 'right',
          filterable: true,
          width: 110,
          format: 'currency',
          renderValue: this.formattedCurrencyColor,
        },
        {
          name: 'ngr_sum',
          align: 'right',
          filterable: true,
          width: 110,
          format: 'currency',
          renderValue: this.formattedCurrencyColor,
        },
        {
          name: 'net_project_profit_sum',
          align: 'right',
          filterable: true,
          width: 110,
          format: 'currency',
          renderValue: this.formattedCurrencyColor,
        },
        {
          name: 'cost_per_player',
          align: 'right',
          filterable: true,
          width: 110,
          format: 'currency',
        },
        {
          name: 'created_at',
          align: 'left',
          filterable: true,
          sortable: 'custom',
          format: 'date-time',
          width: 150,
        },
      ],
      loading: false,
      formaters: Formatters,
      channel_id: '',
      listener: '',
    };
  },
  created() {
    this.setFromQuery(this.passedParams);

    if (!this.passedParams?.period) {
      this.period = allTimePeriod;
    }
    // this.actions.operations.map((e) => {
    //   if (e.component) e.component = e.component.bind(this);
    // });
    this.$store.dispatch('getCurrencies', {});
  },
  activated() {
    this.clearTooltip();
  },
  mounted() {
    this.channel_id = this.$route.params.id;
    this.clearTooltip();
  },
  computed: {
    currencyLabel() {
      return this.getCurrencyLabel(this.$store.state.mediaBuying.campaignsCurrencyCode);
    },
    rows() {
      return this.$store.state.mediaBuying.campaigns.map((p) => ({
        ...p,
        channel_status: p.status,
        campaign_name: {
          text: p.name,
          count: p.needs_attention_total,
        },
      }));
    },
    statusChannel() {
      return this.$store.state.mediaBuying.channel.status !== 'active';
    },
    statusFilters() {
      return [
        {
          id: '',
          text: this.$t('mediaBuying.campaigns.all_campaigns'),
        },
        {
          id: 'active',
          text: this.$t('mediaBuying.campaigns.active_campaigns'),
        },
        {
          id: 'archived',
          text: this.$t('mediaBuying.campaigns.archived_campaigns'),
        },
      ];
    },
    actions() {
      const operations = [
        {
          name: 'show',
          componentAlt: {
            component: UiTableAction,
            props: (row) => ({
              tooltipContent: this.$t('mediaBuying.channels.show'),
              iconClass: 'far fa-eye',
              colorPreset: 'green',
              wrapperClass: 'not-mobile:!tw-hidden',
              onClick: () => {
                this.handleCheckedRows(null, null, row);
              },
            }),
          },
        },
        {
          name: 'edit',
          componentAlt: {
            component: UiTableAction,
            props: (row) => ({
              tooltipContent: this.$t('mediaBuying.channels.edit'),
              iconClass: 'far fa-pen',
              colorPreset: 'green',
              onClick: () => {
                this.editCampaign(row);
              },
            }),
          },
        },
        {
          name: 'archive',
          visible: (row) => row.status === 'active',
          componentAlt: {
            component: UiTablePopoverAction,
            props: (row) => ({
              tooltipContent: this.$t('mediaBuying.channels.archive'),
              iconClass: 'far fa-archive',
              colorPreset: 'red',
              width: 250,
              message: this.$t('mediaBuying.campaigns.archive_message'),
              buttons: [
                {
                  text: this.$t('mediaBuying.channels.cancel'),
                },
                {
                  text: this.$t('mediaBuying.channels.archive'),
                  type: 'danger',
                  click: () => this.editStatusCampaign(row),
                },
              ],
              // const disabled =
              //   row.balance_sum > 0 ||
              //   row.payments_on_review_sum > 0 ||
              //   row.payments_not_finished_count > 0 ||
              //   row.posts_not_finished_count > 0;
              disabled: false,
            }),
          },
        },
        {
          name: 'active',
          visible: (row) => row.status === 'archived',
          componentAlt: {
            component: UiTablePopoverAction,
            props: (row) => ({
              tooltipContent: this.$t('mediaBuying.channels.restore'),
              iconClass: 'far fa-history',
              colorPreset: 'green',
              width: 270,
              message: this.$t('mediaBuying.campaigns.restore_message'),
              buttons: [
                {
                  text: this.$t('mediaBuying.channels.cancel'),
                },
                {
                  text: this.$t('mediaBuying.channels.restore'),
                  type: 'success',
                  click: () => this.editStatusCampaign(row),
                },
              ],
            }),
          },
        },
      ];

      return {
        fixed: 'right',
        width: 80,
        name: () => this.$t('profile.apiKeys.table.actions'),
        operations,
      };
    },
  },
  methods: {
    onPeriodUpdate(value) {
      this.period = value?.period === 2 ? allTimePeriod : value;
    },
    formattedCurrencyColor(v) {
      if (v === null) {
        return '—';
      }

      const amount = v;
      let sum = this.$filters.currency(amount, this.currencyLabel, null, {
        symbolOnLeft: true,
        spaceBetweenAmountAndSymbol: false,
        decimalSeparator: ',',
      });
      sum = sum.includes('NaN') ? amount : sum;

      if (amount < 0) {
        return `<span class="text-red">${sum}</span>`;
      }

      if (amount > 0) {
        return `<span class="text-green">${sum}</span>`;
      }

      return `<span>${sum}</span>`;
    },

    fetchDataAction() {
      this.fetchData({
        ...this.offsetParams,
        ...this.sorting,
        needs_attention_first: this.needs_attention_first,
        status: this.status,
        search: this.search,
      });
    },

    addCampaign() {
      this.$refs.editCampaign.open({ edited: false });
    },
    editCampaign(row) {
      this.$refs.editCampaign.open({
        ...row,
        name: row.name,
        edited: true,
      });
    },
    selectStatusCampaign(v) {
      this.resetPager();
      v === 'all' ? (v = '') : null;
      this.fetchData({
        ...this.offsetParams,
        status: v,
        search: this.search,
      });
    },
    editStatusCampaign(row) {
      if (row.status === 'active') {
        this.$store
          .dispatch('postCampaignArchive', row.id)
          .then(() => {
            this.fetchData({
              ...this.offsetParams,
              status: this.status,
              search: this.search,
            });
            this.$alert.success(
              this.$t('mediaBuying.campaigns.archive_success_message'),
            );
          })
          .catch((e) => {
            const { message } = e.response.data;

            if (message) {
              this.$alert.error(message);
            }
          });
      } else {
        this.$store.dispatch('postCampaignActivate', row.id).then(() => {
          this.fetchData({
            ...this.offsetParams,
            status: this.status,
            search: this.search,
          });
          this.$alert.success(
            this.$t('mediaBuying.campaigns.restore_success_message'),
          );
        });
      }
    },
    handleCheckedRows(id, ids, row) {
      localStorage.setItem(
        'getBackUrlCampaign',
        JSON.stringify(this.$route.path),
      );
      this.$router.push(
        `/dashboard/media-buying-campaigns-details/${row.id}/${this.compressUrlQuery({
          ...row,
          campaign_id: row.id,
          status: '',
        })}`,
      );
      document.removeEventListener('mouseup', this.listener);
    },
    back() {
      this.$router.push(JSON.parse(localStorage.getItem('getBackUrlChannel')));
      document.removeEventListener('mouseup', this.listener);
    },
    clearTooltip() {
      document.addEventListener(
        'mouseup',
        (this.listener = () => {
          const tooltip = document.querySelectorAll('.el-tooltip__popper');
          tooltip.forEach((e, i) => {
            tooltip[i].style.display = 'none';
          });
        }),
      );
    },
    // currencyFormatter(amount, code) {
    //   amount = amount.toFixed(2);
    //   const amountData = amount.split('.');
    //   const result = (+amountData[0]).toLocaleString();

    //   const miscCurrencies = this.$store.state.misc.currencies;
    //   const currency = miscCurrencies.find(
    //     c => (code ? code.toLowerCase() : null) === c.code?.toLowerCase(),
    //   );

    //   if (!code) {
    //     return `${result}.${amountData[1]}`;
    //   }

    //   if (!currency) {
    //     return `${result}.${amountData[1]}`;
    //   }

    //   return `${currency.code.toUpperCase()} ${result}.${amountData[1]}`;
    // },
  },
};
</script>

<style lang="scss">
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/mediabuying/mediabuying';

.media-buying-ad {
  @media (min-width: 651px) {
    .period-wr {
      .ui-select {
        width: 200px !important;
      }

      .el-input .el-input__inner {
        min-width: 200px;
        max-width: 200px;
      }
    }
  }

  &__table {
    .table-card__header-center {
      flex-wrap: wrap;
      align-items: center;
    }

    .table-card__header-left {
      display: contents;
    }

    .table-card__header-title {
      flex: 1 0 100%;
      justify-content: space-between;
    }

    .campaign-add-btn--header {
      display: inline-flex;
    }

    .campaign-add-btn--inline {
      display: none;
    }

    @media (min-width: 1560px) {
      .campaign-add-btn--header {
        display: none;
      }

      .campaign-add-btn--inline {
        display: block;
      }
    }
  }
}
</style>
